import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSWRConfig } from 'swr'
import { useDispatch } from 'react-redux'
import ButtonMin from '@/components/ButtonMin'
import DialogRegisterQuestionnaire from '@/components/DialogRegisterQuestionnaire'
import Select from '@/components/Select'
import Checkbox from '@/components/Checkbox'
import Radio from '@/components/Radio'
import Input from '@/components/Input'
import { useForm as registerUseForm } from 'react-hook-form'
import {
  urlquestionnairestype,
  urlquestionnairesanswer,
  urlaccount,
} from '@/lib/custom'
import { originalUseSWR } from '@/lib/originalUseSWR'
import { dialogRegisterQuestionnaireState } from '@/features/dialogRegisterQuestionnaireSlice'
import { jwttokenState, availableState } from '@/features/authSlice'

import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js'
import awsConfiguration from '@/lib/awsconfiguration'

const RegisterQuestionnaire = ({ accountState }) => {
  const dispatch = useDispatch()
  const { mutate } = useSWRConfig()
  const [errorState, setErrorState] = useState({
    state: 0,
    message: '',
    code: 'error',
  })

  const [RegisterQuestState, setRegisterQuestState] = useState<any>()
  const [AccountState, setAccountState] = useState<any>()

  /**
   * 初回アカウント登録アンケート
   */

  useEffect(() => {
    setAccountState(accountState)
    console.log(accountState)
  }, [accountState])

  useEffect(() => {
    if (AccountState !== undefined) {
      ;(async () => {
        const res = await originalUseSWR(`${urlquestionnairestype}/1`)

        const registerQuestionnaireData = (await res) as any

        if (registerQuestionnaireData.status === 404) {
          localStorage.setItem(
            `${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`,
            'answered'
          )

          dispatch(dialogRegisterQuestionnaireState(true))
          dispatch(jwttokenState(true))
          location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/`

          return
        }

        if (registerQuestionnaireData.status === 400) {
          if (
            localStorage.getItem(
              `${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`
            )
          ) {
            location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/`
          }

          return
        }

        dispatch(availableState(false))
        setRegisterQuestState(registerQuestionnaireData.questionnaires)
      })()
    }
  }, [AccountState])

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = registerUseForm()

  const onSubmitDialog = async (
    data: { [s: string]: string } | ArrayLike<string[]>
  ) => {
    const answerArray = []
    let answerValue: string

    for (let i = 0; i <= Object.keys(data).length - 1; i++) {
      if (Object.values(data)[i] === null) {
        answerValue = ''
      } else if (typeof Object.values(data)[i] === 'object') {
        answerValue = Object.values(data)[i].join(',')
      } else {
        answerValue = Object.values(data)[i]
      }

      const answer = {}
      answer['id'] = Object.keys(data)[i]
      answer['answer'] = answerValue
      answerArray.push(answer)
    }

    try {
      // const authAccoutFetch = await fetch(
      //   `${urlaccount}?username=${accountState.account}`,
      //   {
      //     headers: {
      //       'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      //     },
      //   }
      // )

      // const authAccoutFetchResult = await authAccoutFetch.json()
      // const { user } = authAccoutFetchResult

      // ユーザー認証
      const authenticationDetails = new AuthenticationDetails({
        Username: accountState.account,
        Password: accountState.password,
      })

      // ユーザープール
      const userPool = new CognitoUserPool({
        UserPoolId: awsConfiguration.UserPoolId,
        ClientId: awsConfiguration.ClientId,
      })

      // ユーザーを定義
      const cognitoUser = new CognitoUser({
        Username: accountState.account,
        Pool: userPool,
      })

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          const cognitoUser01 = userPool.getCurrentUser()
          cognitoUser01.getSession((err, session) => {
            if (err) {
              alert(err.message || JSON.stringify(err))
              return
            }

            const registerQuestionnaires = async () => {
              const registerQuestionnairesFunc = await fetch(
                `${urlquestionnairesanswer}/1`,
                {
                  method: 'POST',
                  headers: {
                    'X-Authorization': `${session
                      .getAccessToken()
                      .getJwtToken()}`,
                    'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
                  },
                  body: JSON.stringify({
                    questionnaireItemAnswer: answerArray,
                  }),
                }
              )

              const result = await registerQuestionnairesFunc.json()

              mutate(`${urlquestionnairesanswer}/1`)

              if (result.status === 400) {
                // cognitoUser.signOut()
                // removeLocalStorage()
                setErrorState(result)
                localStorage.setItem(
                  `${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`,
                  'unanswered'
                )
              }

              if (result.status === 200) {
                // @ts-ignore
                window.session = session
                // アクセストークの有効期限
                localStorage.setItem(
                  `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`,
                  session.getAccessToken().getJwtToken()
                )
                localStorage.setItem(
                  `${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`,
                  'answered'
                )

                dispatch(dialogRegisterQuestionnaireState(true))
                location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/`
              }
            }

            registerQuestionnaires()
          })
        },
        onFailure: (err) => {
          console.log(err)
        },
      })
    } catch (error) {
      console.log(error)
    }
  }

  if (RegisterQuestState === undefined) return <div>{''}</div>
  if (!RegisterQuestState) return <div>{''}</div>

  return (
    <DialogRegisterQuestionnaire
      title={`${RegisterQuestState.title}`}
      discription="イベントをより良いものにするために簡単なアンケートにお答えください。"
      buttonOn={true}
    >
      <p className="questerror mt-5 text-xs">{errorState.message}</p>

      <form
        className="mt-4"
        method=""
        action=""
        onSubmit={handleSubmit(onSubmitDialog)}
      >
        <fieldset>
          {RegisterQuestState &&
            RegisterQuestState.items.map((content, i) => {
              let formValueSplit = []
              if (content.formValue !== null) {
                formValueSplit = content.formValue
              }

              if (content.formType == 1) {
                return (
                  <div className={`relative ${2 < i ? 'mt-6' : ''}`} key={i}>
                    <Input
                      labelname={`${formValueSplit[0]}`}
                      htmlfor={`${content.id}`}
                      type="text"
                      placeholder=""
                      register={register}
                    />
                  </div>
                )
              }

              if (content.formType == 2) {
                return (
                  <div className={`relative ${2 < i ? 'mt-6' : ''}`} key={i}>
                    <span className="text-sm text-black">
                      {content.question}
                    </span>
                    <div>
                      <Checkbox
                        htmlfor={`${content.id}`}
                        register={register}
                        formValueSplit={formValueSplit}
                      />
                    </div>
                  </div>
                )
              }

              if (content.formType == 3) {
                return (
                  <div className={`relative ${2 < i ? 'mt-6' : ''}`} key={i}>
                    <span className="text-sm text-black">
                      {content.question}
                    </span>
                    <div>
                      <Radio
                        htmlfor={`${content.id}`}
                        register={register}
                        formValueSplit={formValueSplit}
                      />
                    </div>
                  </div>
                )
              }
              if (content.formType == 4) {
                return (
                  <div
                    className={`relative ${content.id >= 2 ? 'mt-6' : ''}`}
                    key={content.id}
                  >
                    <label className="mt-3 block">
                      <span className="text-sm text-black">
                        {content.question}*
                      </span>
                      <div className="c-select_wrap relative">
                        <Select
                          labelname={`${content.id}`}
                          count={content.id}
                          formValueSplit={formValueSplit}
                          register={register}
                        />
                      </div>
                    </label>
                  </div>
                )
              }

              if (content.formType == 5) {
                return (
                  <div
                    className={`relative ${2 < i ? 'mt-6' : ''}`}
                    key={content.id}
                  >
                    <label className="mt-3 block">
                      <span className="text-sm text-black">
                        {content.question}
                      </span>
                      <div className="relative">
                        <textarea
                          name={content.id}
                          className="c-textarea_wrap"
                          id=""
                          {...register(`${content.id}`)}
                        ></textarea>
                      </div>
                    </label>
                  </div>
                )
              }
            })}
        </fieldset>
        <div className="mt-10">
          <ButtonMin text="回答する" type="submit" state={false} />
        </div>
      </form>
    </DialogRegisterQuestionnaire>
  )
}

export default RegisterQuestionnaire
